import React from 'react';
import { useTranslation } from 'react-i18next';
import SnapshotCard, { summarizeSnapshot } from './SnapshotSections';

// Re-exported for existing importers (tests, selector summary lines).
export { summarizeSnapshot };

// Side-by-side holistic cards: perimetre, biens supports, measures per analysis.
const HolisticCompare = ({ snapshots }) => {
  const { t } = useTranslation();

  if (!snapshots?.length) return null;

  return (
    <div className="space-y-3">
      <div className="bg-white rounded-xl shadow-sm border border-slate-200 px-4 py-3 flex flex-wrap items-center gap-2">
        <h3 className="text-sm font-semibold text-slate-700">
          {t('fusionPtr.holisticView', 'Vue globale des analyses')}
        </h3>
        <span className="ml-auto text-[11px] text-slate-500 tabular-nums">
          {t('fusionPtr.holisticTotals', '{{analyses}} analyse(s) · {{measures}} mesures', {
            analyses: snapshots.length,
            measures: snapshots.reduce((sum, s) => sum + (s.measures?.length || 0), 0),
          })}
        </span>
      </div>
      <div className={`grid grid-cols-1 gap-4 ${snapshots.length > 1 ? 'xl:grid-cols-2' : ''}`}>
        {snapshots.map((snap) => (
          <SnapshotCard key={String(snap.analysisId)} snap={snap} />
        ))}
      </div>
    </div>
  );
};

export default HolisticCompare;
